export const MetaTagMixins = {
  metaTag() {
    return this.$router.currentRoute.meta;
  },
};
